import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Fa from 'react-fontawesome';
import { reduce } from 'lodash';
import {
  Modal, Button, PanelGroup, Panel,
} from 'react-bootstrap';
import { getFontSize, FONT_SIZES, USER_PREFERENCE_FONT_SIZE } from '../../AppReducer';
import {
  getCollectorLanguageMappings,
  getCollectorLanguageShowModal,
  getUserCurrentOrganization,
  getUser,
} from '../../../Auth/AuthReducer';
import { hideCollectorLanguageMappingModal } from '../../../Auth/AuthActions';
import LanguageForm from '../CollectorLanguageMapping/form';
import AnnualSalesGoalForm from '../AnnualSalesGoal';
import SalesManagerForm from '../SalesManager';

const TAB_FONT_SIZE = 'font-size';
const TAB_LANGUAGES = 'languages';
const TAB_SALES_GOAL = 'annual-sales-goal';
const TAB_SALES_MANAGER = 'sales-manager';

function hasSalesGoalSet(value) {
  return value !== null && value !== undefined;
}

function hasSalesManager(value) {
  return value !== null && value !== undefined;
}

function getActiveKey(props) {
  const { annualSalesGoal, salesManager } = props;
  if (props.showLanguageSelector) {
    return TAB_LANGUAGES;
  }
  if (!hasSalesGoalSet(annualSalesGoal)) {
    return TAB_SALES_GOAL;
  }
  if (!hasSalesManager(salesManager)) {
    return TAB_SALES_MANAGER;
  }
  return TAB_FONT_SIZE;
}

class UISettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      updating: false,
      activeKey: getActiveKey(props),
    };
    this.done = this.done.bind(this);
    this.updateFontSize = this.updateFontSize.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props.showLanguageSelector && nextProps.showLanguageSelector) {
      this.setState({ activeKey: getActiveKey(nextProps) });
    } else if (!nextProps.requiredAnnualSalesGoal && nextProps.requiredAnnualSalesGoal && !hasSalesGoalSet(nextProps.annualSalesGoal)) {
      this.setState({ activeKey: getActiveKey(nextProps) });
    } else if (!nextProps.requiredSalesManager && nextProps.requiredSalesManager && !hasSalesManager(nextProps.salesManager)) {
      this.setState({ activeKey: getActiveKey(nextProps) });
    }
  }

  updateFontSize(size) {
    this.setState({ updating: true }, () => {
      this.context.updateUserPreference(USER_PREFERENCE_FONT_SIZE, size)
        .then(() => { this.setState({ updating: false }); });
    });
  }

  handleSelect(activeKey) {
    this.setState({ activeKey });
  }

  done() {
    this.props.onClose();
    if (this.props.showLanguageSelector) {
      this.props.dispatch(hideCollectorLanguageMappingModal());
    }
  }

  renderFontSizeChanger() {
    const { updating, activeKey } = this.state;
    const { fontSize } = this.props;
    const isActive = activeKey === TAB_FONT_SIZE;
    return (
      <Panel
        eventKey={TAB_FONT_SIZE}
      >
        <Panel.Heading>
          <Panel.Title>
            <Panel.Toggle componentClass="div" style={{ cursor: 'pointer' }}>
              <table>
                <tbody>
                  <tr>
                    <td width="99%" className="text-active">Font Size</td>
                    <td style={{ verticalAlign: 'top', paddingLeft: 10 }}><Fa name={isActive ? 'caret-up' : 'caret-down'} /></td>
                  </tr>
                </tbody>
              </table>
            </Panel.Toggle>
          </Panel.Title>
        </Panel.Heading>
        <Panel.Body collapsible>
          <div>
            {FONT_SIZES.map((s) => {
              const stl = { fontSize: `${s}em` };
              const active = s === fontSize;
              const cls = active ? 'text-active' : 'text-muted';
              let fa = 'circle-o';
              let spin = false;
              if (active) {
                if (updating) {
                  fa = 'spinner';
                  spin = true;
                } else {
                  fa = 'check-circle';
                }
              }
              return (
                <Button key={s} disabled={updating} bsStyle="link" onClick={() => { this.updateFontSize(s); }}>
                  <Fa className={cls} name={fa} spin={spin} /> <Fa style={stl} name="font" />
                </Button>
              );
            })}
          </div>
        </Panel.Body>
      </Panel>
    );
  }

  renderLanguageSelector() {
    const { activeKey } = this.state;
    const { mappings } = this.props;
    const isActive = activeKey === TAB_LANGUAGES;
    if (!mappings || mappings.length === 0) {
      return null;
    }

    const unmappedCollectors = reduce(mappings, (items, item) => {
      if (item.selected_language === undefined) {
        items.push(item);
      }
      return items;
    }, []);
    const required = unmappedCollectors.length > 0;

    return (
      <Panel
        eventKey={TAB_LANGUAGES}
      >
        <Panel.Heading>
          <Panel.Title>
            <Panel.Toggle componentClass="div" style={{ cursor: 'pointer' }}>
              <table>
                <tbody>
                  <tr>
                    <td width="99%" className="text-active">
                      Outreach Languages
                      {required && <span>&nbsp;<Fa name="exclamation-triangle" className="text-danger" /></span>}
                    </td>
                    <td style={{ verticalAlign: 'top', paddingLeft: 10 }}><Fa name={isActive ? 'caret-up' : 'caret-down'} /></td>
                  </tr>
                </tbody>
              </table>
            </Panel.Toggle>
          </Panel.Title>
        </Panel.Heading>
        <Panel.Body collapsible>
          <div>
            <p>Please select your default language for requesting feedback:</p>
            {isActive && <LanguageForm />}
          </div>
        </Panel.Body>
      </Panel>
    );
  }

  renderAnnualSalesGoal() {
    const { requiredAnnualSalesGoal, annualSalesGoal } = this.props;
    if (!requiredAnnualSalesGoal) {
      return null;
    }
    const { activeKey } = this.state;
    const isActive = activeKey === TAB_SALES_GOAL;
    const required = requiredAnnualSalesGoal && !hasSalesGoalSet(annualSalesGoal);

    return (
      <Panel
        eventKey={TAB_SALES_GOAL}
      >
        <Panel.Heading>
          <Panel.Title>
            <Panel.Toggle componentClass="div" style={{ cursor: 'pointer' }}>
              <table>
                <tbody>
                  <tr>
                    <td width="99%" className="text-active">
                      Annual Sales Goal
                      {required && <span>&nbsp;<Fa name="exclamation-triangle" className="text-danger" /></span>}
                    </td>
                    <td style={{ verticalAlign: 'top', paddingLeft: 10 }}><Fa name={isActive ? 'caret-up' : 'caret-down'} /></td>
                  </tr>
                </tbody>
              </table>
            </Panel.Toggle>
          </Panel.Title>
        </Panel.Heading>
        <Panel.Body collapsible>
          <div>
            {isActive && <AnnualSalesGoalForm />}
          </div>
        </Panel.Body>
      </Panel>
    );
  }

  renderMySalesManager() {
    const { requiredSalesManager, salesManager } = this.props;
    if (!requiredSalesManager) {
      return null;
    }
    const { activeKey } = this.state;
    const isActive = activeKey === TAB_SALES_MANAGER;
    const required = requiredSalesManager && !hasSalesManager(salesManager);

    return (
      <Panel
        eventKey={TAB_SALES_MANAGER}
      >
        <Panel.Heading>
          <Panel.Title>
            <Panel.Toggle componentClass="div" style={{ cursor: 'pointer' }}>
              <table>
                <tbody>
                  <tr>
                    <td width="99%" className="text-active">
                      My Sales Manager
                      {required && <span>&nbsp;<Fa name="exclamation-triangle" className="text-danger" /></span>}
                    </td>
                    <td style={{ verticalAlign: 'top', paddingLeft: 10 }}><Fa name={isActive ? 'caret-up' : 'caret-down'} /></td>
                  </tr>
                </tbody>
              </table>
            </Panel.Toggle>
          </Panel.Title>
        </Panel.Heading>
        <Panel.Body collapsible>
          <div>
            {isActive && <SalesManagerForm />}
          </div>
        </Panel.Body>
      </Panel>
    );
  }

  render() {
    const {
      open, requiredAnnualSalesGoal, annualSalesGoal, isAdmin, requiredSalesManager, salesManager
    } = this.props;
    const { activeKey } = this.state;
    const disabledASG = requiredAnnualSalesGoal && !hasSalesGoalSet(annualSalesGoal);
    const disabledSM = requiredSalesManager && !hasSalesManager(salesManager);
    const disabled = disabledASG || disabledSM;
    return (
      <Modal show={open} onHide={this.done}>
        <Modal.Header closeButton={!disabled}>
          <Modal.Title><Fa name="sliders" /> User Settings</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <PanelGroup
            accordion
            id="user-settings"
            activeKey={activeKey}
            onSelect={this.handleSelect}
          >
            {this.renderFontSizeChanger()}
            {this.renderLanguageSelector()}
            {!isAdmin && this.renderAnnualSalesGoal()}
            {!isAdmin && this.renderMySalesManager()}
          </PanelGroup>
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="default" onClick={this.done} disabled={disabled}>Done</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state, ownProps) {
  const showLanguageSelector = getCollectorLanguageShowModal(state);
  const user = getUser(state);
  const isAdmin = user.role === 'admin' || user.role === 'superadmin' || user.organization_role === 'admin';
  const annualSalesGoal = user ? user.annual_sales_goal : null;
  const salesManager = user ? user.sales_manager : null;
  const organization = getUserCurrentOrganization(state);
  const requiredAnnualSalesGoal = organization.annual_sales_goals === true;
  const requiredSalesManager = organization.sales_manager_selection === true;
  let open = showLanguageSelector || ownProps.open;
  if (!open && (requiredAnnualSalesGoal && !isAdmin) && !hasSalesGoalSet(annualSalesGoal)) {
    open = true;
  }

  return {
    open,
    fontSize: getFontSize(state),
    mappings: getCollectorLanguageMappings(state),
    showLanguageSelector,
    annualSalesGoal,
    salesManager,
    requiredAnnualSalesGoal: requiredAnnualSalesGoal && !isAdmin,
    requiredSalesManager: requiredSalesManager && !isAdmin,
    isAdmin,
  };
}

UISettings.propTypes = {
  dispatch: PropTypes.func.isRequired,
  fontSize: PropTypes.number.isRequired,
  mappings: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  open: PropTypes.bool,
  showLanguageSelector: PropTypes.bool,
  onClose: PropTypes.func,
  requiredAnnualSalesGoal: PropTypes.bool,
  requiredSalesManager: PropTypes.bool,
  annualSalesGoal: PropTypes.number,
  salesManager: PropTypes.string,
  isAdmin: PropTypes.bool,
};
UISettings.defaultProps = {
  open: false,
  showLanguageSelector: false,
  onClose: () => {},
  annualSalesGoal: null,
  salesManager: null,
  requiredAnnualSalesGoal: false,
  requiredSalesManager: true,
  isAdmin: false,
};
UISettings.contextTypes = {
  updateUserPreference: PropTypes.func.isRequired,
  getUserPreference: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(UISettings);
